module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticStyle: {
      "background-color": "#f1f1f1"
    },
    attrs: {
      "id": "main"
    }
  }, [_c('el-header', {
    attrs: {
      "id": "nav"
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "active-text-color": "#409EFF"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-menu-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "index": "4"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://bootdo.com",
      "target": "_blank"
    }
  }, [_vm._v("关于作者")])]), _vm._v(" "), _c('el-menu-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "index": "3"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("clouddo开源项目")])]), _vm._v(" "), _c('el-menu-item', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "index": "2"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://bootdo.com"
    }
  }, [_vm._v("bootdo开源项目")])])], 1)], 1), _vm._v(" "), _c('el-main', {
    attrs: {
      "id": "content"
    }
  }, [_c('el-carousel', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "indicator-position": "outside"
    }
  }, [_c('el-carousel-item', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10,
      "offset": 7
    }
  }, [_c('div', [_c('h1', [_vm._v("BootDo")]), _vm._v(" "), _c('h2', [_vm._v("\n                基于springboot的开源框架"), _c('br'), _vm._v("单体项目急速开发利器\n              ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "round": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://gitee.com/lcg0124/bootdo/wikis/Home"
    }
  }, [_vm._v("起步")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "round": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://gitee.com/lcg0124/bootdo"
    }
  }, [_vm._v("源码")])])], 1)])], 1)], 1), _vm._v(" "), _c('el-carousel-item', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10,
      "offset": 7
    }
  }, [_c('div', [_c('h1', [_vm._v("CloudDo")]), _vm._v(" "), _c('h2', [_vm._v("\n                基于springcloud的开源框架"), _c('br'), _vm._v("微服务入门\n              ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "round": ""
    }
  }, [_vm._v("起步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "round": ""
    }
  }, [_vm._v("源码")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "shadow": "always"
    }
  }, [_c('h3', [_vm._v("大道至简")]), _vm._v(" "), _c('p', [_vm._v("减少过度封装，展现技术本质")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "shadow": "hover"
    }
  }, [_c('h3', [_vm._v("开源精神")]), _vm._v(" "), _c('p', [_vm._v("做简洁高效，易于上手的开源项目")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "shadow": "never"
    }
  }, [_c('h3', [_vm._v("不懈追求")]), _vm._v(" "), _c('p', [_vm._v("技术服务于人，服务于生活")])])], 1)], 1)], 1), _vm._v(" "), _c('el-footer', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("保留权利")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25abc2b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome/index.vue
// module id = 1155
// module chunks = 2